export const PUBLIC_PATHS: string[] = ["/login", "/setup"];
